export const VERTEX = /* glsl */ `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;
export const FRAGMENT = /* glsl */ `
  uniform float uTime;
  uniform vec2 uDrift;
  uniform float uNoiseScale;
  uniform vec3 uCloudColor;
  uniform float uDensity;
  uniform float uOpacity;
  varying vec2 vUv;
  float hash21(vec2 p) {
    return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
  }
  float valueNoise(vec2 p) {
    vec2 i = floor(p);
    vec2 f = fract(p);
    vec2 u = f * f * (3.0 - 2.0 * f);
    float a = hash21(i + vec2(0.0, 0.0));
    float b = hash21(i + vec2(1.0, 0.0));
    float c = hash21(i + vec2(0.0, 1.0));
    float d = hash21(i + vec2(1.0, 1.0));
    return mix(mix(a, b, u.x), mix(c, d, u.x), u.y);
  }
  float fbm(vec2 p) {
    float sum = 0.0;
    float amp = 0.5;
    for (int i = 0; i < 4; i++) {
      sum += valueNoise(p) * amp;
      p *= 2.0;
      amp *= 0.5;
    }
    return sum;
  }
  void main() {
    vec2 uv = vUv * uNoiseScale + uDrift * uTime;
    float n = fbm(uv);
    float alpha = smoothstep(uDensity, uDensity + 0.3, n) * uOpacity;
    gl_FragColor = vec4(uCloudColor, alpha);
  }
`;
